module.exports = __webpack_public_path__ + "img/20.e09c8c6b.jpg";